import { NgModule } from '@angular/core'

import { RouterModule, Routes } from '@angular/router'
import { GbCategoriesListComponent } from './gb-categories-list/gb-categories-list.component'
import { GbCategoryViewComponent } from './gb-category-view/gb-category-view.component'
import { CategoryViewGuard } from 'libs/gb-front/category/util/src'

export class CategoryConstants {
  public static CATEGORIES = 'categories'
  public static CATEGORIES_UUID = ':uuid'
}

const routes: Routes = [
  {
    path: '',
    component: GbCategoriesListComponent,
  },
  {
    path: CategoryConstants.CATEGORIES_UUID,
    component: GbCategoryViewComponent,
    canActivate: [CategoryViewGuard],
  },
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GbFrontCategoryRoutingModule {}
